import { useTranslation } from "react-i18next"

import { FileText } from "@/components/icons"

import { CollapsibleManagementSection } from "./collapsible-management-section"
import { DelegationModeControl } from "./delegation-mode-control"
import { SkillGuidancePanel } from "./skill-guidance-panel"

/**
 * "Skill guidance" management section.
 *
 * Global markdown overlays for the document skills, rendered by
 * ``SkillGuidancePanel``.
 */
export function SkillsManagementSection() {
  const { t } = useTranslation()

  return (
    <CollapsibleManagementSection
      headerActions={<DelegationModeControl capability="skills" />}
      icon={<FileText className="size-5" />}
      id="skills"
      storageKey="admin-management-skills-expanded"
      title={t("adminDashboard.systemConfig.skillGuidanceSectionTitle", {
        defaultValue: "Skill guidance",
      })}
    >
      <div className="space-y-3">
        <p className="text-muted-foreground text-xs">
          {t("adminDashboard.systemConfig.skillGuidanceSectionDescription", {
            defaultValue:
              "Global markdown overlays for DOCX, PDF, PPTX, and XLSX. Enabled autoload entries are injected only when the matching skill is loaded.",
          })}
        </p>
        <SkillGuidancePanel />
      </div>
    </CollapsibleManagementSection>
  )
}
